import { createSvgIcon } from "@mui/material";

export const ForgeIconRegular = createSvgIcon(
  <svg viewBox="0 0 512 512" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M355.285 97.7883C365.168 106.688 365.96 121.799 357.061 131.683L338.325 152.491L448.941 225.715C465.001 236.274 467.984 259.413 455.07 273.756L326.597 416.44C313.749 430.708 290.432 430.301 278.179 415.366L181.458 297.867C179.414 295.354 177.036 293.213 174.398 291.51L47.4322 207.601C31.3719 197.042 28.3891 173.903 41.3033 159.56L169.776 16.8765C182.691 2.5338 206.015 3.08161 218.194 17.9502L302.654 120.373L321.39 99.5647C330.289 89.6808 345.401 88.8889 355.285 97.7883ZM89.4201 177.856L200.838 251.534L200.913 251.601C207.512 255.928 213.457 261.281 218.525 267.459L303.446 370.566L407.027 255.527L295.535 181.782C288.935 177.455 282.99 172.102 277.922 165.924L193.001 62.8173L89.4201 177.856Z"
      fill="currentColor"
    />
    <path
      d="M156.753 318.279L172.18 337.014L46.5843 476.502C37.6848 486.386 22.5735 487.178 12.6896 478.278C2.80582 469.379 2.01387 454.268 10.9133 444.384L136.509 304.896L156.753 318.279Z"
      fill="currentColor"
    />
    <path
      d="M448 67.9998C444.3 67.9998 441.1 70.4998 440.2 74.0998L433.4 101.4L406.1 108.2C402.5 109.1 400 112.3 400 116C400 119.7 402.5 122.9 406.1 123.8L433.4 130.6L440.2 157.9C441.1 161.5 444.3 164 448 164C451.7 164 454.9 161.5 455.8 157.9L462.6 130.6L489.9 123.8C493.5 122.9 496 119.7 496 116C496 112.3 493.5 109.1 489.9 108.2L462.6 101.4L455.8 74.0998C454.9 70.4998 451.7 67.9998 448 67.9998Z"
      fill="currentColor"
    />
    <path
      d="M432 352C428.4 352 425.3 354.4 424.3 357.8L409.5 409.5L357.8 424.3C354.4 425.3 352 428.4 352 432C352 435.6 354.4 438.7 357.8 439.7L409.5 454.5L424.3 506.2C425.3 509.6 428.4 512 432 512C435.6 512 438.7 509.6 439.7 506.2L454.5 454.5L506.2 439.7C509.6 438.7 512 435.6 512 432C512 428.4 509.6 425.3 506.2 424.3L454.5 409.5L439.7 357.8C438.7 354.4 435.6 352 432 352Z"
      fill="currentColor"
    />
    <path
      d="M184 416C180.3 416 177.1 418.5 176.2 422.1L169.4 449.4L142.1 456.2C138.5 457.1 136 460.3 136 464C136 467.7 138.5 470.9 142.1 471.8L169.4 478.6L176.2 505.9C177.1 509.5 180.3 512 184 512C187.7 512 190.9 509.5 191.8 505.9L198.6 478.6L225.9 471.8C229.5 470.9 232 467.7 232 464C232 460.3 229.5 457.1 225.9 456.2L198.6 449.4L191.8 422.1C190.9 418.5 187.7 416 184 416Z"
      fill="currentColor"
    />
  </svg>,
  "ForgeIconRegular",
);
